<template>
<div id="map">
   <dashboard-toggler/>
   <div class="base-layer-selector-wrapper">
      <base-layer-selector/>
   </div>
</div>
</template>

<script>
import DashboardToggler from '../../../atoms/Home/DashboardToggler';
import BaseLayerSelector from '../../../molecules/Home/BaseLayerSelector';

export default {
   components: {
      DashboardToggler,
      BaseLayerSelector,
   },
}
</script>

<style lang="scss" scoped>
@import '~ol/ol.css';

#map {
   position: relative;
   background: $secondary-bg;
   width: 100%;
   height: 100%;
   overflow: hidden;
   border: none;
}
</style>